import { getClient, SessionData } from '@chegg/rio-sdk-web'
import { ClientInterface } from '@chegg/rio-sdk-web/dist/types/types'
import { Target } from 'redux-beacon'
import { isProduction } from '@chegg-wt/core/utils/env'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import { EventWithConfig } from './types'
import { rioEvent } from './utils/rioEvent'
/* eslint-disable import/extensions */
import { EventSchemas } from './rsw/eventSchemas'

export const getRioClient = (): ClientInterface<EventSchemas> => getClient<EventSchemas>()
export const initializeRioClient = (options: SessionData) => getRioClient().init(options)

const rioAnalytics = (): Target => (events: EventWithConfig[]) => {
  if (typeof window === 'undefined') {
    return
  }

  const client = getRioClient()

  events.forEach((event) => {
    const { payload, config, testOnly = false } = event
    const shouldEnable = testOnly ? !isProduction() : true
    if (typeof payload === 'object' && shouldEnable) {
      rioEvent(client, payload, config).catch((e) => trackWithoutThrow(e))
    }
  })
}

export default rioAnalytics
